import { EventEmitter, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthResourceServerErrorHandler } from 'angular-oauth2-oidc';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {

    private static pendingRequestsCount: number = 0;
    public static readonly pendingRequestsCountEvents: EventEmitter<number> = new EventEmitter<number>(true);

    private concernedUrls: string[] = ['/api'];

    constructor(private router: Router, private errorHandler: OAuthResourceServerErrorHandler) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.concernedUrls.find(url => req.url.indexOf(url) >= 0)) {
            return next.handle(req);
        }
        // TODO the user's locale should be injected here
        const headers = req.headers.set('Accept-Language', 'fr-FR');
        req = req.clone({headers});
        ApiInterceptor.pushRequest();
        return next.handle(req)
            .pipe(
                catchError(err => this.handleError(err)),
                finalize(() => ApiInterceptor.popRequest())
            );
    }

    private static pushRequest(): void {
        ApiInterceptor.pendingRequestsCountEvents.emit(++ApiInterceptor.pendingRequestsCount);
    }

    private static popRequest(): void {
        ApiInterceptor.pendingRequestsCountEvents.emit(--ApiInterceptor.pendingRequestsCount);
    }

    private handleError(err): Observable<any> {
        if (err instanceof HttpErrorResponse) {
            if (err.status === 401 || err.status === 403) {
                this.router.navigateByUrl('/auth');
            } else if (err.status === 404) {
                this.router.navigateByUrl('/');
            }
        }
        return this.errorHandler.handleError(err);
    }
}
